import React from 'react';
import CaseStudyCard from './CaseStudyCard';
import PostCarousel from '../shared/PostCarousel/PostCarousel';
import { getRelatedCaseStudies } from '../../content/case-studies';

/** "More case studies" strip at the bottom of a case-study detail page. */
const RelatedCaseStudies = ({ post }) => {
  const related = getRelatedCaseStudies(post, 2);
  if (related.length === 0) return null;

  return (
    <PostCarousel
      items={related}
      itemKey={(item) => item.slug}
      renderItem={(item) => <CaseStudyCard post={item} />}
      title="Weitere Case Studies"
      subtitle="Weitere Branchenlösungen, die zeigen, wie wir digitale Prozesse für den Mittelstand umsetzen."
      viewAllTo="/case-studies"
      viewAllLabel="Alle Case Studies →"
      ariaLabel="Weitere Case Studies"
    />
  );
};

export default RelatedCaseStudies;
